import { render, staticRenderFns } from "./UkStep3.vue?vue&type=template&id=5d6b405c"
import script from "./UkStep3.vue?vue&type=script&lang=js"
export * from "./UkStep3.vue?vue&type=script&lang=js"
import style0 from "./UkStep3.vue?vue&type=style&index=0&id=5d6b405c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports